import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";
// oxlint-disable-next-line no-restricted-imports
import { PageHeader } from "#components/organisms/PageHeader/PageHeader";
import { Box } from "#shared/view/components/Box";
import { Stack } from "#shared/view/components/Stack";

const PageContent = ({ children }: { children: React.ReactNode }) => (
  <Box
    px={spacing[8]}
    flex={1}
    style={{ display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden" }}
  >
    {children}
  </Box>
);

export const Page = ({ children }: { children: React.ReactNode }) => (
  <Stack
    h="100%"
    gap={0}
    bg={colors.bg.elevation.primary}
    style={{ overflow: "hidden", containerType: "inline-size" }}
  >
    {children}
  </Stack>
);

Page.Content = PageContent;
Page.Header = PageHeader;
